import _ from 'lodash';

import { SHOW_MODAL, HIDE_MODAL, MODAL_HIDDEN } from './action-types';


export default function modals(state = { modalState: {} }, action) {
  const newState = _.assign({}, state);

  switch (action.type) {
    case SHOW_MODAL:
      newState.showModal = true;
      newState.modalState = action.modalState;
      break;
    case HIDE_MODAL:
      newState.showModal = false;
      break;
    case MODAL_HIDDEN:
      newState.modalState = {};
      newState.showModal = false;
      break;
    default:
      return state;
  }
  
  return newState;
}
